import dayjs from 'dayjs'

export const toLocalTz = (string) => {
  //this will change tz without changing hour
  // 2022-01-01T:00:00Z
  // --> 2022-01-01T:00:00 -3:00

  return dayjs(string).utc().tz(dayjs.tz.guess(), true).format()
}
